module.exports = __webpack_public_path__ + "static/media/striped_bar_postlapAERO_hand_tall.e4fc5ce2.svg";